export default {
  methods: {
    filter(filters) {
      this.filters = { ...filters }
    },
    clearFilters() {
      Object.keys(this.configuration.aggregations).map((v) => {
        this.filters[v] = []
      })
    },
    watchFilters() {
      Object.keys(this.configuration.aggregations).map((v) => {
        this.$watch("filters." + v, () => {
          this.$events.$emit("searched")
        })
      })

      this.$watch("order", () => {
        this.$events.$emit("searched")
      })
    },
  },
  computed: {
    hasFilters() {
      return (this?.results?.data?.aggregations && Object.keys(this.results.data.aggregations).length > 0) ?? false
    },
  },
}
